"use client";

import { useEffect, useMemo } from "react";
import { QRCodeSVG } from "qrcode.react";
import { StoreLinkButton } from "../atoms/StoreLinkButton";
import { XSvg } from "../atoms/XSvg";
import AppStoreLogo from "../atoms/AppStoreLogo";
import PlayStoreLogo from "../atoms/PlayStoreLogo";
import classNames from "classnames";
import { Inter } from "next/font/google";
import { trackPopupShowed, trackPopupClosed } from "@/utils/mixpanel";
const inter = Inter({ subsets: ["latin"] });

export const QrCodeModal = ({
	onClose = () => {},
	areaData = {},
	link,
	pageTitle,
	isMobile,
}) => {
	const scanDetectableQrUrl = useMemo(() => {
		// const url = generateQrScannedDetectionUrl(link, areaData);
		const url = new URL(link);
		const params = new URLSearchParams(url.search);

		Object.entries(areaData).forEach(([key, value]) => {
			if (value) {
				params.append(key, value.toString());
			}
		});

		url.search = params.toString();
		return url.toString();
	}, [link, areaData]);

	useEffect(() => {
		trackPopupShowed();
	}, []);

	return (
		<div className="fixed inset-0 w-screen h-screen bg-white/75 z-[9999] backdrop-blur-[20px]">
			<XSvg
				size={48}
				className="absolute top-12 right-12 cursor-pointer"
				onClick={() => {
					trackPopupClosed();
					onClose();
				}}
			/>
			<div className="m-auto flex flex-col items-center justify-center w-full h-full">
				<div className="bg-white rounded-2xl border border-zinc-200">
					<QRCodeSVG
						size={260}
						value={scanDetectableQrUrl}
						className="m-8"
					/>
					<div className="flex justify-between border-t border-zinc-200">
						<StoreLinkButton
							isMobile={isMobile}
							pageTitle={pageTitle}
							link={link}
							name="appstore">
							<AppStoreLogo />
						</StoreLinkButton>
						<StoreLinkButton
							isMobile={isMobile}
							pageTitle={pageTitle}
							link={link}
							name="playstore">
							<PlayStoreLogo />
						</StoreLinkButton>
					</div>
				</div>
				<div
					className={classNames(
						inter.className,
						"text-lg leading-relaxed mt-5"
					)}>
					<p>Download Gluten Free Eats by Atly</p>
				</div>
			</div>
		</div>
	);
};
